(() => {
 const selector='.product-card-wrapper .media--hover-effect';
 function update(media){
  const images=media.querySelectorAll('img');
  images.forEach(image=>image.classList.remove('studio-image-pending','studio-image-ready'));
  const secondary=images[1];
  media.classList.toggle('izuro-secondary-ready',Boolean(secondary?.complete&&secondary.naturalWidth>0));
 }
 function scan(root){
  if(root.nodeType!==1&&root.nodeType!==9)return;
  if(root.matches?.(selector))update(root);
  root.querySelectorAll(selector).forEach(update);
 }
 // Capturing load/error also covers cards replaced by collection filtering.
 document.addEventListener('load',event=>{const media=event.target.closest?.(selector);if(media)update(media);},true);
 document.addEventListener('error',event=>{const media=event.target.closest?.(selector);if(media)update(media);},true);
 scan(document);
 const main=document.querySelector('main');
 if(main)new MutationObserver(records=>{
  for(const record of records){
   if(record.type==='attributes'){const media=record.target.closest?.(selector);if(media)update(media);}
   else record.addedNodes.forEach(scan);
  }
 }).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
 document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
